<template>
  <div class="cart">
    <CartBody :isCart="true" :showDailyKarmaWidget="true" />
  </div>
</template>

<script setup>
  import { onMounted } from 'vue';
  import CartBody from './components/cart-body.vue';

  onMounted(() => {
    logCartDetailsToSegment();
  });

  const logCartDetailsToSegment = () => {
    const customerDetails = window?.getCustomerDetails?.();
    const gtmDetails = JSON.parse(localStorage.getItem('___ELEVAR_GTM_SUITE--params') || '{}');

    analytics.track('Cart Viewed', {
      fbcid: gtmDetails?.fbclid,
      gclid: gtmDetails?.gclid,
    },
    {
      ...(customerDetails ? { userId: customerDetails?.segmentUserId } : {}),
      context: {
        traits: {
          ...(customerDetails
            ? { stio_unique_user_id: customerDetails?.segmentUserId, email: customerDetails?.email }
            : {}),
        },
      },
    });
  }
</script>
